
import {defineComponent} from "vue";
import {TextContentRestDtoModel} from "@/models/api/pharma-cms-content-block/TextContentRestDtoModel";
import {CbStructureMixin} from "@/components/layouts/content-pages/wysiwyg/structures/CbStructureMixin";
import {NormalContentBlockRestService} from "@/services/rest/cms-content-block/NormalContentBlockRestService";
import {FindNormalContentBlockPayload} from "@/models/payload/FindNormalContentBlockPayload";
import {CreateNormalContentBlockPayload} from "@/models/payload/CreateNormalContentBlockPayload";
import {SaveNormalContentBlockPayload} from "@/models/payload/SaveNormalContentBlockPayload";
import {CopyCpAbstractPayload} from "@/models/payload/CopyCpAbstractPayload";
import BaseSpinner from "@/components/UI/Bootstrap/BaseSpinner.vue";
import InputTextEditor from "@/components/UI/InputTextEditor.vue";

export default defineComponent({
  name: "CbText",
  components: {InputTextEditor, BaseSpinner},
  extends: CbStructureMixin,
  data: () => ({
    contentBlock: TextContentRestDtoModel.createWithDefaults(),
  }),
  watch: {
    contentBlock() {
      this.onCopyCpAbstractChanged();
    },
  },
  methods: {
    async find(payload: FindNormalContentBlockPayload): Promise<TextContentRestDtoModel> {
      return await NormalContentBlockRestService.getInstance().findText(payload.type, payload.id);
    },
    async create(payload: CreateNormalContentBlockPayload): Promise<string> {
      return await NormalContentBlockRestService.getInstance().createText(payload.cb as TextContentRestDtoModel, payload.type);
    },
    async save(payload: SaveNormalContentBlockPayload): Promise<void> {
      await NormalContentBlockRestService.getInstance().saveText(payload.cb as TextContentRestDtoModel, payload.type, payload.id);
    },
    getDefaultCbModel(): TextContentRestDtoModel {
      return TextContentRestDtoModel.createWithDefaults();
    },
    onCopyCpAbstractChanged(): void {
      const content = this.contentBlock.content?.nl ?? null;
      this.copyCpAbstractPayload = new CopyCpAbstractPayload(content, null, null);

      this.$emit('abstractContentChanged', this.copyCpAbstractPayload);
    },
  }
});
